import React, { useContext, useEffect, useState } from 'react';
import { Snackbar, Alert } from '@mui/material';
import { errorContext } from './ErrorDisplay';

// Single, app-wide notification surface (MUI Snackbar + Alert) for every server
// API error and success. Rendered once at the app root; pages just call
// handleError / setErrorMessage / notify on errorContext and the message shows
// here in a uniform, dismissible toast. Each notification carries a fresh `key`,
// so even the same text re-opens the toast.
function Notifier() {
  const { notification } = useContext(errorContext);
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState(null);

  useEffect(() => {
    if (notification && notification.message) {
      setCurrent(notification);
      setOpen(true);
    }
  }, [notification]);

  function handleClose(event, reason) {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  }

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        onClose={handleClose}
        severity={current?.severity || 'error'}
        variant="filled"
        sx={{ width: '100%' }}
      >
        {current?.message}
      </Alert>
    </Snackbar>
  );
}

export default Notifier;
